import { FC, ReactNode } from 'react';

interface KpiCardProps {
  icon: string;
  value: string | number | ReactNode;
  label: string;
  sublabel?: string;
  accentColor?: string;
  children?: ReactNode;
}

/**
 * Card numérico estilo BI. Usa CSS classes do tema (h.lab) para herdar dark/light.
 *
 * `value` aceita number (formatado em pt-BR automaticamente), string ou ReactNode
 * (útil quando o valor precisa de cor condicional, ex: NPS verde/âmbar/vermelho).
 */
const KpiCard: FC<KpiCardProps> = ({ icon, value, label, sublabel, accentColor, children }) => {
  const formatted =
    typeof value === 'number' ? value.toLocaleString('pt-BR') : value;

  return (
    <div className="kpi-card bg-surface-card border border-theme-border rounded-xl p-5 flex flex-col gap-2">
      <div className="flex items-center gap-3">
        <div
          className="w-10 h-10 shrink-0 rounded-lg flex items-center justify-center text-accent-contrast"
          style={{ backgroundColor: accentColor ?? 'var(--accent)' }}
        >
          <span className="material-symbols-outlined">{icon}</span>
        </div>
        <span className="min-w-0 text-content-muted text-xs uppercase tracking-wide leading-snug">{label}</span>
      </div>
      <div className="text-3xl font-bold text-content-primary">{formatted}</div>
      {sublabel && <div className="text-xs text-content-muted">{sublabel}</div>}
      {children}
    </div>
  );
};

export default KpiCard;
